import { ComponentType, lazy } from 'react';

export const CUSTOM_PAGES: Record<string, ComponentType> = {
  ConnectYourDomain: lazy(() => import('../DomainNotConnected')),
};

export const STANDALONE_CODES = Object.keys(CUSTOM_PAGES);
